import React from 'react';
import { GridContainer, Grid } from '@trussworks/react-uswds';

export function USWDSGridContainer(props) {
  return <GridContainer {...props} />;
}
export function USWDSGrid(props) {
  return <Grid {...props} />;
}
